import { type ComponentPropsWithoutRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { SidebarResizer, type SidebarResizerProps } from './SidebarResizer';

export type SidebarProps = ComponentPropsWithoutRef<'div'> & Pick<SidebarResizerProps, 'localStorageKey' | 'size'>;

export const Sidebar = memo(({ children, className, localStorageKey, size, ...restOfProps }: SidebarProps) => {
  return (
    <div
      className={cn(
        'flex h-full w-[var(--sidebar-width)] flex-col items-stretch border-r border-r-gray-4 bg-gray-1',
        className,
      )}
      data-testid="SIDEBAR"
      {...restOfProps}
    >
      {children}
      <SidebarResizer localStorageKey={localStorageKey} size={size} />
    </div>
  );
});

Sidebar.displayName = 'Sidebar';
